import Middleware from "../middleware";

Middleware.wishlist = async function ({ store, $bugsnag }) {
  if (process.client) {
    return;
  }

  try {
    await store.dispatch("wishlist/fetchCustomer");
    await store.dispatch("wishlist/fetchWishlist");
  } catch (err) {
    $bugsnag.notify(err, e => {
      e.addMetadata("Wishlist Middleware", {
        message: "Error in wishlist middleware",
      });
    });
  }
};
